import { Pipe, PipeTransform } from '@angular/core';
import { ORing } from 'src/app/models';

@Pipe({
  name: 'oringTempRange'
})
export class ORingTempRangePipe implements PipeTransform {

  transform(detail: ORing): string {
    if (detail?.minTemp === -1 || detail?.maxTemp === -1 ) return 'Consult Engineering';
    return `${detail?.minTemp}°F to ${detail?.maxTemp}°F`;
  }

}
